// This is used client and server side, so can't use ES6 exports
module.exports = (searchRequest) => {
    return (
        !!searchRequest.neLat &&
        !!searchRequest.neLong &&
        !!searchRequest.swLat &&
        !!searchRequest.swLong &&
        !!searchRequest.zoom
    );
};
